import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import { addDeveloper, getProjectData } from "../../AdminServices/AdminProjectService";
import frameBg from "../../../../Assets/FrameBGDashboard.png";
import NotificationAlert from "../../../Alerts/NotificationAlert";
 import { useNavigate } from "react-router-dom";

const AddDeveloperModal = ({ show, onClose, projectUID, onAdded }) => {
   const navigate = useNavigate();
  const [projects, setProjects] = useState([]);
  const [form, setForm] = useState({
    projectUID: projectUID || "",
    userUID: "",
    roleID: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState(null);

  useEffect(() => {
    if (show) {
      loadProjects();
      setForm({
        projectUID: projectUID || "",
        userUID: "",
        roleID: "",
      });
      setErrors({});
    }
  }, [show]);

  const loadProjects = async () => {
    try {
      const res = await getProjectData();
      if (res.data.status === "Success") {
        setProjects(res.data.data);
      }
    } catch (e) {
      if (e.response?.status === 400) {
      navigate("/bad-request", {
        state: {
          error: e.response?.data?.message || "Bad request (400)",
        },
      });
      return;
    }
      console.error("Error loading projects:", e);
    }
  };

  const validate = () => {
    const temp = {};
    if (!form.projectUID) temp.projectUID = "Project is required.";
    if (!form.userUID.trim()) temp.userUID = "Developer UserUID is required.";
    if (!form.roleID.trim()) temp.roleID = "Role ID is required.";
    return temp;
  };

 const handleSubmit = async () => {
  const validation = validate();
  if (Object.keys(validation).length > 0) {
    setErrors(validation);
    return;
  }

  setErrors({});
  setLoading(true);

  try {
    const payload = {
      projectUID: form.projectUID,
      userUID: form.userUID,
      roleID: Number(form.roleID),
    };

    const res = await addDeveloper(payload);

    if (res.data.status === "Success") {
      setAlert({
        type: "success",
        message: res.data.message || "Developer added successfully!",
      });

      onAdded();

      setTimeout(() => {
        setAlert(null);
        onClose();
      }, 4000);
    } else {
      setAlert({
        type: "error",
        message: res.data.message || "Something went wrong.",
      });
    }
  } catch (err) {
     if (err.response?.status === 400) {
      navigate("/bad-request", {
        state: {
          error: err.response?.data?.message || "Bad request (400)",
        },
      });
      return;
    }
    setAlert({
      type: "error",
      message:
        err.response?.data?.message || err.message || "Something went wrong.",
    });
  }

  setLoading(false);
};

  if (!show) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-40 flex justify-end z-50"
      onClick={onClose}
    >
      <div
        className="bg-white w-full max-w-4xl h-full shadow-2xl border-l border-gray-200 flex flex-col animate-slideIn overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div
          className="flex justify-between items-center px-8 py-6 border-b text-white shadow-md bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${frameBg})` }}
        >
          <h2 className="text-2xl font-semibold">Add Developer</h2>
          <button onClick={onClose}>
            <X size={26} />
          </button>
        </div>

        {/* Form */}
        <div className="flex-1 overflow-y-auto px-8 py-6 space-y-6">
          {/* Project Dropdown */}
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Select Project <span className="text-red-500">*</span>
            </label>
            <select
              value={form.projectUID}
              onChange={(e) =>
                setForm((prev) => ({ ...prev, projectUID: e.target.value }))
              }
              className={`w-full p-2 border rounded-md mt-1 text-sm ${
                errors.projectUID ? "border-red-500" : ""
              }`}
            >
              <option value="">Select Project</option>
              {projects.map((p) => (
                <option key={p.projectUID} value={p.projectUID}>
                  {p.projectName}
                </option>
              ))}
            </select>
            {errors.projectUID && (
              <p className="text-xs text-red-500 mt-1">{errors.projectUID}</p>
            )}
          </div>

          {/* Developer UserUID */}
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Developer <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              value={form.userUID}
              onChange={(e) =>
                setForm((prev) => ({ ...prev, userUID: e.target.value }))
              }
              className={`w-full p-2 border rounded-md mt-1 text-sm ${
                errors.userUID ? "border-red-500" : ""
              }`}
              placeholder="Enter UserUID"
            />
            {errors.userUID && (
              <p className="text-xs text-red-500 mt-1">{errors.userUID}</p>
            )}
          </div>

          {/* Role ID */}
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Role ID <span className="text-red-500">*</span>
            </label>
            <input
              type="number"
              value={form.roleID}
              onChange={(e) =>
                setForm((prev) => ({ ...prev, roleID: e.target.value }))
              }
              className={`w-full p-2 border rounded-md mt-1 text-sm ${
                errors.roleID ? "border-red-500" : ""
              }`}
              placeholder="Enter Role ID"
            />
            {errors.roleID && (
              <p className="text-xs text-red-500 mt-1">{errors.roleID}</p>
            )}
          </div>
        </div>

        {/* Footer */}
        <div className="px-8 py-4 border-t bg-white flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-5 py-2 text-sm border rounded-md text-gray-600 hover:bg-gray-100"
            disabled={loading}
          >
            Cancel
          </button>

          <button
            onClick={handleSubmit}
            className="px-6 py-2 text-sm bg-gradient-to-r from-[#0061A4] to-[#00ACED] text-white rounded-md shadow hover:opacity-90"
            disabled={loading}
          >
            {loading ? "Adding..." : "Add Developer"}
          </button>
        </div>
      </div>

       {/* Alerts */}
      {alert && (
        <NotificationAlert
          type={alert.type}
          message={alert.message}
          show={true}
          duration={4000}
          onClose={() => setAlert(null)}
        />
      )}
    </div>
  );
};

export default AddDeveloperModal;
